import React from 'react'

const overlayContext = React.createContext({
    overlay: '',
    showOverlay: '',
    setShowoverlay: () => {}
})
export const OverlaysProvider = overlayContext.Provider
export default overlayContext